<template>
  <div class="shortcuts py-4">
    <span class="fst-italic">Acessos rápidos:</span>
    <router-link :to="{ name: 'finances.index' }" v-if="shortcuts.includes('budget')">
      <h6 class="title mx-5">
        <img src="/images/v2/layout/icon-add-budget.svg" alt="icon budget" class="icon">
        <span>{{ $t('add_budget') }}</span>
      </h6>
    </router-link>
    <router-link :to="{ name: 'advertisers.create' }" v-if="shortcuts.includes('create_advertiser')">
      <h6 class="title mx-5">
        <img src="/images/v2/layout/icon-edit.svg" alt="icon edit" class="icon"><span>{{ $t('create_advertiser') }}</span>
      </h6>
    </router-link>
    <router-link :to="{ name: 'campaigns.create' }" v-if="shortcuts.includes('create_campaign')">
      <h6 class="title mx-5">
        <img src="/images/v2/layout/icon-edit.svg" alt="icon edit" class="icon"><span>{{ $t('create_campaign') }}</span>
      </h6>
    </router-link>
    <router-link :to="{ name: 'users.index' }" v-if="shortcuts.includes('users')">
      <h6 class="title mx-5">
        <img src="/images/v2/layout/icon-config.svg" alt="icon edit" class="icon"><span>{{ $t('manage_users') }}</span>
      </h6>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Shortcuts',
  props: ['mainShortcut', 'shortcuts']
}
</script>

<style lang="scss" scoped>
  .shortcuts {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    background-color: $color1;
    width: 100%;
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);

    .title {
      display: flex;
      gap: .5rem;
      align-items: center;
      margin-bottom: 0;

      span {
        font-weight: 700;
        text-decoration: underline;
      }

      .icon {
        width: 15px;
      }
    }
  }
</style>
